import findings from './findings/index'

export default {
  findings,
}
